// extracted by mini-css-extract-plugin
export default {"blackboard":"Blackboard_blackboard__mLq13","canvas":"Blackboard_canvas__0xNg1","tools":"Blackboard_tools__M85JL","left":"Blackboard_left__Ja0Vh"};